import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
        <ul class="actions01 questions-header-actions">
            <li ng-if="vm.QuestionService.canManageQuestionRelatedData()"
                ng-click="vm.addQuestions()">
                    <span class="icon-v2-rounded">
                        <file-file-icon filename="'icon.plus'"></file-file-icon>
                    </span>
                    {{ 'questions.Manual add' | translate }}
            </li>
            <li ng-if="vm.QuestionService.canManageQuestionRelatedData()"
                ng-click="vm.importQuestions()">
                    <span class="icon-v2-rounded">
                        <file-file-icon filename="'icon.plus'"></file-file-icon>
                    </span>
                    {{ 'questions.Import questions' | translate }}
            </li>
        </ul>
    `
})

export default class {
    constructor ($state, $rootScope, ModalService, QuestionService) {
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.ModalService = ModalService;
        this.QuestionService = QuestionService;
    }

    addQuestions () {
        const { $state, $rootScope } = this;
        this.ModalService.open({
            template: '<modals-question-add sites="vm.sites" class="wrapper" uib-modal-instance="vm.$uibModalInstance"/>',
            resolve: {
                sites: (SiteResource) => {
                    return SiteResource.query({
                        formSites: true,
                        fields: 'id,name',
                        pageSize: 0
                    }).$promise;
                }
            },
            controller (sites, $uibModalInstance) {
                this.sites = sites;
                this.$uibModalInstance = $uibModalInstance;
            },
            size: 'xlarge'
        }).then((response) => {
            $rootScope.$broadcast('questionIsAdded');
            $state.go('authorized.forms.questions.all.question', {
                id: response.id
            });
        });
    }

    importQuestions () {
        return this.ModalService.open({
            template: '<modals-question-import class="wrapper" cancel="vm.$uibModalInstance.dismiss()" update="vm.update()"/>',
            controller ($uibModalInstance, $rootScope) {
                this.$uibModalInstance = $uibModalInstance;
                this.update = () => {
                    $rootScope.$broadcast('questionIsAdded');
                    this.$uibModalInstance.close();
                };
            },
            size: 'xlarge'
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/questions/actions/index.js